import React, { FC, ReactNode, CSSProperties } from 'react'
import classnames from 'classnames/bind'
import styles from './styles.scss'
const cx = classnames.bind(styles)

interface PageWrapperProps {
  children?: ReactNode
  className?: string
  style?: CSSProperties
}

const PageWrapper: FC<PageWrapperProps> = ({
  children,
  className,
  style = {},
}) => {
  return (
    <div style={style} className={cx('wrapper', className)}>
      {children}
    </div>
  )
}

export default PageWrapper
